
import React, { useState } from "react";
import { supabase } from "../../supabaseClient";
import "../../styles/GuestLogin.css"; // Reuse your existing CSS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';

export default function UpdatePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleUpdate = async (e) => {
    e.preventDefault();
    
    // Validation
    if (newPassword.length < 6) {
      setMessage({ text: "Password must be at least 6 characters.", type: "error" });
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage({ text: "Passwords do not match!", type: "error" });
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPassword });

    if (error) {
      setMessage({ text: error.message, type: "error" });
    } else {
      setMessage({ text: "Password updated! Redirecting to login...", type: "success" });
      // Wait 3 seconds then send them to the home page to login
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    }
    setLoading(false);
  };

  return (
    <div className="login-overlay">
      <div className="login-container" style={{ height: "auto" }}>
        <div className="login-side visible" style={{ position: "relative" }}>
          <h2 className="login-title">Secure Your Account</h2>
          <p style={{ textAlign: 'center', fontSize: '14px', color: '#666', marginBottom: '20px' }}>
            Please enter a new password for your Victoria Sports Club account.
          </p>

          {message.text && (
            <div className={`status-msg ${message.type}`}>{message.text}</div>
          )}

          <form onSubmit={handleUpdate}>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                className="login-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="toggle-pass" 
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash } />
              </button>
            </div>

            <input
              type="password"
              placeholder="Confirm New Password"
              className="login-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <button className="login-primary-btn" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}